export const THUMBNAIL = 'thumbnail-link';
export const CROP = 'crop-link';
export const DELETE = 'delete-link';
export const EDIT = 'edit-link';
